export default "https://cdn-static.gokick.com/assets/5330764b9b84e4374a94f4eff9433164072ac9e6/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";